import React from "react";
import { Users } from "./Users";
import { usersHook } from "./hooks/usersHook";

// eslint-disable-next-line react/display-name
export default () => <Users {...usersHook()}  />;
